<template>
    <div class="submenuBtn flex flex-col">
        <div class="submenuBtn-main" @click="onMainClick">
            <UButton
                class="ml-4 text-md whitespace-nowrap text-navigation-icon hover:text-navigation-icon-hover"
                :label="link.label ? link.label : 'Submenu Item fallback'"
                :class="{ '!text-text-primary': isActiveLink }"
                :to="link.action || hasChildren ? undefined : (link.to || undefined)"
                size="lg"
                color="neutral"
                variant="ghost"
                activeClass="router-link-active"
                exactActiveClass="router-link-exact-active"
                @click="onButtonClick"
            >
                <template #trailing>
                    <UIcon
                        v-if="hasChildren"
                        class="transition-transform flex"
                        :class="{ 'rotate-180': subMenuHandler }"
                        name="i-heroicons-solid:chevron-down"
                    />
                </template>
            </UButton>
        </div>
        <template v-if="hasChildren">
            <SideNavigationGridExpander
                v-for="item in link.subItems"
                :key="item.label"
                :isClosed="!subMenuHandler"
                class="ml-8"
            >
                <div class="flex w-max h-full">
                    <div class="w-px h-full bg-[var(--ui-border)] overflow-hidden" />
                    <SideNavigationSubmenuBtn :link="item" :expandSubMenuProp="expandSubMenuProp" />
                </div>
            </SideNavigationGridExpander>
        </template>
    </div>
</template>

<script setup lang="ts">
const route = useRoute()
const emit = defineEmits(['selected'])

interface SubmenuBtnLink {
    id?: number
    label: string
    icon?: string
    to?: string
    action?: string
    color?: string
    toolTip?: string
    subItems?: SubmenuBtnLink[]
}

interface Props {
    link: SubmenuBtnLink
    expandSubMenuProp?: boolean
}

const {
    link,
    expandSubMenuProp = false,
} = defineProps<Props>()

const isNavClosed = useState<boolean>('isNavClosed')
const menuAction = useState<string | null>('menuAction', () => null)

const unfoldSubMenu = ref(false)
const hasChildren = computed(() => (link.subItems?.length ?? 0) > 0)
const subMenuHandler = computed(() => unfoldSubMenu.value || expandSubMenuProp)

const isActiveLink = computed(() => {
    const to = link.to?.trim()
    return !!to && route.path === to
})

watch(isNavClosed, (closed) => {
    if (closed) unfoldSubMenu.value = false
})

function onMainClick() {
    if (hasChildren.value) unfoldSubMenu.value = !unfoldSubMenu.value
}

function onButtonClick(event: MouseEvent) {
    if (link.action) {
        event.preventDefault()
        event.stopPropagation()
        menuAction.value = link.action
        isNavClosed.value = true
        return
    }

    if (hasChildren.value) {
        event.preventDefault()
        emit('selected', link.id)
        return
    }

    emit('selected', link.id)
    if (link.to) isNavClosed.value = true
}
</script>
